/**
 * Richtwerte für den Besetzungs-Vorschlag im Event-Editor (Gästezahl → Personalbedarf, siehe
 * BEDARFSPLANER.md §5). Fürs Erste feste Werte (nicht pro Betrieb konfigurierbar): "Gäste je benötigter
 * Kraft" je Bereich, gematcht über ein Schlüsselwort im Bereichsnamen (case-insensitive Teilstring),
 * sonst der Standardwert. Wird direkt vom Frontend gelesen.
 */
export const BesetzungsRichtwerte = {
    standard: 30,
    proBereich: [
        { schluessel: 'service', gaesteJeKraft: 25 },
        { schluessel: 'küche', gaesteJeKraft: 40 },
        { schluessel: 'kueche', gaesteJeKraft: 40 },
        { schluessel: 'bar', gaesteJeKraft: 50 },
    ],
};

/**
 * Ermittelt den Richtwert (Gäste je Kraft) für einen Bereichsnamen.
 * @param {string} bereichName
 * @returns {number}
 */
export function gaesteJeKraftFuerBereich(bereichName) {
    const name = (bereichName || '').toLowerCase();
    const treffer = BesetzungsRichtwerte.proBereich.find((r) => name.includes(r.schluessel));
    return treffer ? treffer.gaesteJeKraft : BesetzungsRichtwerte.standard;
}
